/**
 * å­å¨ä¸äºå¸¸ç¨çå°å(æ¯å¦åå°å°åç­)
 */
export class NecUrl {
  static SERVER_URL = 'http://localhost:10001';
  static EXAM_WEB_URL = 'http://localhost:10001';
}
